import { render, staticRenderFns } from "./Tier.vue?vue&type=template&id=f5ee3ac6&scoped=true&"
import script from "./Tier.vue?vue&type=script&lang=ts&"
export * from "./Tier.vue?vue&type=script&lang=ts&"
import style0 from "./Tier.vue?vue&type=style&index=0&id=f5ee3ac6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ee3ac6",
  null
  
)

export default component.exports